import { axiosInstance as axios } from '../../utils';
import _ from 'lodash';

import { FETCH_HOME } from "./types";

import { dispatchNotAuthorized } from './authActions';

export const fetchHomeData = () => async dispatch => {
  const response = await axios.get('/home');
  if (response.status === 200) {
    dispatch({ type: FETCH_HOME, payload: response.data });
  } else if (response.status === 401) {
    dispatchNotAuthorized();
  }
  return response;
};
